module.exports = __webpack_public_path__ + "static/grimlock-5859d8466afe8e2f2a0408d24a0282ed.jpg";